import { Role } from 'lib/generated/graphql';
import React from 'react';
import useAuth from 'src/shared-components/Auth';
import Builder from './view/builder';
import Customer from './view/customer';

const MyHuddles = () => {
  const { user } = useAuth();
  if (!user) return null;
  // if (user?.role === Role.Builder || user?.customerOnboarding?.completedFirstRequest) {
  if (user?.role === Role.Builder) {
    return <Builder user={user} />;
  } else if (user?.role === Role.Customer) {
    return <Customer user={user} />;
  } else return null;
  // } else {
  //   return <PendingRequest user={user} />;
  // }
};

export default MyHuddles;
